import { motion } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { useState, useEffect, useCallback } from "react";

const reviews = [
  { name: "Ayşe K.", rating: 5, text: "Lazer epilasyon için gittim, sonuçlardan çok memnunum. Hijyenik ortam ve profesyonel ekip. Kesinlikle tavsiye ederim!", time: "2 hafta önce" },
  { name: "Mehmet Y.", rating: 5, text: "Eşime cilt bakımı hediye ettim, çok memnun kaldı. Ortam çok temiz ve profesyonel. Erkekler için de masaj hizmeti mükemmel.", time: "1 ay önce" },
  { name: "Elif D.", rating: 5, text: "Cilt bakımı yaptırdım, cildim ilk seanstan sonra bile gözle görülür şekilde iyileşti. Harika bir deneyimdi.", time: "1 ay önce" },
  { name: "Ahmet B.", rating: 5, text: "Masaj hizmetinden çok memnun kaldım. İş stresinden sonra kendimi yenilenmiş hissettim. Teşekkürler Purevia!", time: "3 hafta önce" },
  { name: "Zeynep M.", rating: 5, text: "Protez tırnak uygulaması çok doğal görünüyor. Emeği geçen herkese teşekkürler!", time: "3 hafta önce" },
  { name: "Burak T.", rating: 5, text: "Kafa masajı için gittim, gerçekten rahatlatıcıydı. Stresim tamamen azaldı. Erkeklere de kesinlikle tavsiye ederim.", time: "2 hafta önce" },
  { name: "Fatma T.", rating: 5, text: "Kafa masajı için gittim, stresim tamamen azaldı. Çok rahatlatıcı bir deneyimdi. Tekrar geleceğim.", time: "1 hafta önce" },
  { name: "Emre Ö.", rating: 5, text: "Bursa'da en profesyonel güzellik merkezi. Eşimle birlikte gidiyoruz, ikimiz de çok memnunuz.", time: "1 ay önce" },
  { name: "Selin A.", rating: 5, text: "Manikür ve pedikür hizmeti mükemmeldi. Hijyen konusunda çok titizler, gönül rahatlığıyla gidebilirsiniz.", time: "2 ay önce" },
  { name: "Oğuzhan K.", rating: 5, text: "Görükle bölgesinde bu kalitede bir yer bulmak zor. Lazer epilasyon sonuçları gerçekten etkileyici.", time: "2 hafta önce" },
  { name: "Merve B.", rating: 5, text: "Bursa'da en iyi güzellik merkezi diyebilirim. Her ziyaretimde aynı kaliteli hizmeti alıyorum.", time: "1 ay önce" },
  { name: "Serkan D.", rating: 5, text: "Masaj terapisi beklentilerimin çok üzerindeydi. Spa kalitesinde bir deneyim yaşadım.", time: "3 hafta önce" },
  { name: "Deniz Ö.", rating: 5, text: "Masaj hizmeti spa kalitesinde. Rahatlatıcı müzik eşliğinde harika bir terapi deneyimi yaşadım.", time: "3 hafta önce" },
  { name: "Hakan M.", rating: 5, text: "Eşim ve ben düzenli olarak geliyoruz. Çalışanlar çok profesyonel ve ilgili. 5 yıldız hak ediyor.", time: "1 ay önce" },
  { name: "Büşra G.", rating: 4, text: "Lazer epilasyon seanslarım devam ediyor, şimdiden ciddi azalma var. Çok memnunum!", time: "2 hafta önce" },
  { name: "Murat A.", rating: 5, text: "Görükle'de yaşıyorum, bu kadar yakında bu kalitede hizmet almak harika. Her ay düzenli geliyorum.", time: "2 hafta önce" },
  { name: "Hande Y.", rating: 5, text: "Cilt bakım protokolleri gerçekten profesyonel. Cildim hiç bu kadar güzel olmamıştı.", time: "1 ay önce" },
  { name: "Tolga Ç.", rating: 5, text: "Arkadaşımın tavsiyesiyle gittim. Kafa masajı inanılmaz rahatlatıcıydı. Düzenli müşteri oldum.", time: "3 hafta önce" },
  { name: "Gül S.", rating: 5, text: "Arkadaşımın tavsiyesiyle gittim ve çok memnun kaldım. Ortam çok temiz ve şık.", time: "2 hafta önce" },
  { name: "Onur S.", rating: 5, text: "Premium cihazları ve uzman kadrosuyla Bursa'nın en iyi güzellik merkezi. Kesinlikle tavsiye ederim.", time: "1 ay önce" },
];

export default function ReviewsSlider() {
  const [current, setCurrent] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setCardsPerView(1);
      else if (window.innerWidth < 1024) setCardsPerView(2);
      else setCardsPerView(3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = reviews.length - cardsPerView;

  const prev = useCallback(() => setCurrent((c) => Math.max(0, c - 1)), []);
  const next = useCallback(() => setCurrent((c) => Math.min(maxIndex, c + 1)), [maxIndex]);

  // Auto-play
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c >= maxIndex ? 0 : c + 1));
    }, 4000);
    return () => clearInterval(timer);
  }, [maxIndex]);

  const cardWidth = 100 / cardsPerView;
  const gapPx = 24;
  const translateX = current * (cardWidth);

  return (
    <section
      id="yorumlar"
      data-testid="reviews-section"
      className="py-24 md:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-16 md:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-4">
              Google Yorumları
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-black">
              Danışanlarımız Ne Diyor?
            </h2>
          </motion.div>
          <div className="hidden sm:flex gap-2">
            <button
              onClick={prev}
              disabled={current === 0}
              data-testid="reviews-prev"
              className="w-12 h-12 flex items-center justify-center border border-[#EBEBEB] hover:border-black transition-colors duration-300 disabled:opacity-30"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={next}
              disabled={current >= maxIndex}
              data-testid="reviews-next"
              className="w-12 h-12 flex items-center justify-center border border-[#EBEBEB] hover:border-black transition-colors duration-300 disabled:opacity-30"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="overflow-hidden">
          <motion.div
            className="flex"
            animate={{ x: `calc(-${translateX}% - ${current * gapPx / cardsPerView}px)` }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{ gap: `${gapPx}px` }}
          >
            {reviews.map((review, i) => (
              <div
                key={i}
                data-testid={`review-card-${i}`}
                className="bg-[#FAFAFA] border border-[#EBEBEB] p-8 flex-shrink-0"
                style={{ width: `calc(${cardWidth}% - ${gapPx * (cardsPerView - 1) / cardsPerView}px)` }}
              >
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star
                      key={s}
                      size={14}
                      className={s < review.rating ? "fill-[#B76E79] text-[#B76E79]" : "text-gray-300"}
                    />
                  ))}
                </div>
                <p className="text-sm leading-relaxed text-black/70 mb-6 min-h-[80px]">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-black">{review.name}</span>
                  <span className="text-xs text-gray-400">{review.time}</span>
                </div>
              </div>
            ))}
          </motion.div>
        </div>

        {/* Mobile controls */}
        <div className="flex sm:hidden justify-center gap-2 mt-8">
          <button
            onClick={prev}
            disabled={current === 0}
            className="w-12 h-12 flex items-center justify-center border border-[#EBEBEB] hover:border-black transition-colors duration-300 disabled:opacity-30"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={next}
            disabled={current >= maxIndex}
            className="w-12 h-12 flex items-center justify-center border border-[#EBEBEB] hover:border-black transition-colors duration-300 disabled:opacity-30"
          >
            <ChevronRight size={18} />
          </button>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center gap-1.5 mt-8">
          {Array.from({ length: Math.ceil(reviews.length / cardsPerView) }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(Math.min(i * cardsPerView, maxIndex))}
              className={`h-1.5 transition-all duration-300 ${
                Math.floor(current / cardsPerView) === i
                  ? "w-8 gold-bg"
                  : "w-1.5 bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
